( function () {
	'use strict';

	function TemplateCategoriesModalController ( logger, collection, $modalInstance, collectionService, TOOLTIP_MESSAGES ) {
		var self = this;

		self.collection      = angular.copy( collection );
		self.disableSave     = false;
		self.categoryLimit   = 5;
		self.minimumTagLimit = 2;
		self.counter         = 1;
		self.tooltip         = TOOLTIP_MESSAGES;
		self.message         = 'Adding and categorizing tags will make it easier to filter out different observations when generating reports.';
		self.suggestion      = 'All categories must have a minimum of two tags.';

		var data = {
			'filterName' : 'New Category',
			'children'   : [ ]
		};

		function save () {
			$modalInstance.close( self.collection );
		}

		function cancel () {
			$modalInstance.dismiss();
		}

		function refineCategoryName ( catName ) {
			catName += ' ' + self.counter++;

			self.collection.some( function ( item ) {
				return item.filterName === catName;
			} );

			return catName;
		}

		function addNewCategory () {
			var newData = angular.copy( data );

			newData.filterName = refineCategoryName( newData.filterName );
			collectionService.addModelWithId( self.collection, newData, 'filterId' );
		}

		function removeCategory ( filter ) {
			collectionService.removeModel( self.collection, filter );
		}

		function activate () {
			logger.info( 'Activated Tags Modal View' );
		}

		self.save           = save;
		self.cancel         = cancel;
		self.addNewCategory = addNewCategory;
		self.removeCategory = removeCategory;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'TemplateCategoriesModalController', TemplateCategoriesModalController );

	TemplateCategoriesModalController.$inject = [ 'logger', 'collection', '$modalInstance', 'collectionService', 'TOOLTIP_MESSAGES' ];
} )( );
